import * as React from 'react';

function SvgOffers(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
			<path
				d="M15.455 3.28h-5.189c.562-.38.896-.812 1.009-1.295a1.672 1.672 0 00-.482-1.531l-.041-.031c-.013-.011-.022-.026-.035-.037A1.638 1.638 0 009.144.084C8.637.27 8.222.714 7.9 1.429 7.574.714 7.161.27 6.654.084A1.64 1.64 0 005.08.386c-.013.01-.024.024-.035.037-.01.013-.028.02-.041.03-.41.394-.593.972-.482 1.532.113.483.447.912 1.01 1.295H.542c-.3 0-.543.245-.543.547v3.401c0 .302.243.547.542.547h.584v7.678c0 .302.243.547.542.547h12.664c.3 0 .542-.245.542-.547V7.775h.584c.3 0 .542-.245.542-.547V3.827a.547.547 0 00-.545-.548zM9.008 4.373v2.308H6.717V4.373h2.29zm.5-3.265a.562.562 0 01.51.107l.02.013.018.02a.587.587 0 01.162.485c-.037.156-.269.656-1.677 1.188.36-1.459.82-1.757.968-1.813zm-3.219 0c.15.056.608.354.968 1.815C5.86 2.392 5.62 1.897 5.582 1.742a.577.577 0 01.165-.499l.015-.017.018-.011a.568.568 0 01.51-.107zM1.083 4.373h4.549v2.308H1.093l-.01-2.308zm1.134 3.402h3.415v7.131H2.217V7.775zm4.5 7.131V7.775h2.29v7.131h-2.29zm7.072 0h-3.688V7.775h3.688v7.131zm1.124-8.225h-4.82V4.373h4.82v2.308z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	);
}

export default SvgOffers;
